<app-gallery-settings-customize-header
  title="Colors"
  location="theme-colors-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group title="Cover" location="theme-colors-customize">
  <app-theme-single-color-item
    [gallery]="gallery()"
    title="Title"
    [icon]="'/assets/icons/color-text.svg'"
    [color]="theme().cover.title_typography.font_color"
    (colorChange)="updateCoverTitle($event)"
  ></app-theme-single-color-item>
  <app-theme-single-color-item
    [gallery]="gallery()"
    title="Description"
    [icon]="'/assets/icons/color-text.svg'"
    [color]="theme().cover.paragraph_typography.font_color"
    (colorChange)="updateCoverParagraph($event)"
  ></app-theme-single-color-item>
  <app-theme-cover-overlay-color-item [gallery]="gallery()"></app-theme-cover-overlay-color-item>
</app-gallery-settings-group>

<app-gallery-settings-group title="Layout View" location="theme-colors-customize">
  <app-theme-single-color-item
    [gallery]="gallery()"
    title="Headings"
    [icon]="'/assets/icons/color-text.svg'"
    [color]="theme().section.title_typography.font_color"
    (colorChange)="updateSectionTitle($event)"
  ></app-theme-single-color-item>
  <app-theme-single-color-item
    [gallery]="gallery()"
    title="Paragraphs"
    [icon]="'/assets/icons/color-text.svg'"
    [color]="theme().section.paragraph_typography.font_color"
    (colorChange)="updateSectionParagraph($event)"
  ></app-theme-single-color-item>
  <app-theme-layout-background-color-item [gallery]="gallery()"></app-theme-layout-background-color-item>
</app-gallery-settings-group>
